export const CATEGORY_IDS = {
    AFTER_EFFECTS_TEMPLATES_ID: 1,
    PREMIERE_PRO_TEMPLATES_ID: 5,
    GRAPHICS_CATEGORY_ID: 15,
};

export const TEMPLATE_DIFFICULTY_LEVELS = {
    SIMPLE: 'simple',
    MEDIUM: 'medium',
    COMPLEX: 'complex',
}

export const GRAPHICS_CATEGORY_ID = 15;
